import React from 'react';
import { ReferenceInput, SelectInput, required } from 'react-admin';
import { Field } from 'redux-form'
import components from 'redux-form-jsonschema-reactstrap'
import getSafe from './util';
import NumberRange from './components/NumberRange'
import RadioRange_InputField from './components/RadioRange_InputField'
import RadioRange_InputField0 from './components/RadioRange_InputField0'
import RadioRange_InArrayLevel1 from './components/RadioRange_InArrayLevel1'
import RadioRange_NewMaterialUI from './components/RadioRange_NewMaterialUI'
import RadioRange_ra from './components/RadioRange_ra'
import Text_ra from './components/Text_ra'
import Text_ra2 from './components/Text_ra2'
import SelectRange_Field from './components/SelectRange_Field'
import SelectRange_InputField from './components/SelectRange_InputField'
import DisabledTextDontSend from './components/DisabledTextDontSend'
import { RequiredInput, NumberRangeRocker, InputCif, DisabledText } from './components/Inputs'

const isRequired = validate => {
    if (validate === required) return true;
    if (Array.isArray(validate)) {
        return validate.includes(required);
    }
    return false;
};

function anewc3(props) {
  const optionText = getSafe(() => props.schemaVis.schema.meta.vis.optionText) || "id"
  const label = getSafe(() => props.schemaVis.schema.meta.vis.label) || props.name
  const reference = props.schemaVis.schema.meta.vis.reference
  const a = (choice) => optionText.map( v=>choice[v]).join(' | ')
  const input = (
    <ReferenceInput source={props.name} reference={reference} validate={required} label={label} {...props}>
      <SelectInput optionText={a} />
    </ReferenceInput>
  )
  return (
    <Field
        {...input.props}
        name={input.props.source}
        component={input.type}
        isRequired={isRequired(input.props.validate)}
    />
  )
}

export default {...components, AORReferenceInput: anewc3,
  DisabledText: DisabledText,
  DisabledTextDontSend: DisabledTextDontSend,
  NumberRange: NumberRange,
  RequiredText: RequiredInput,
  NumberRangeRocker: NumberRangeRocker,
  InputCif: InputCif,
  RadioRange_InputField: RadioRange_InputField,
  RadioRange_InputField0: RadioRange_InputField0,
  RadioRange_InArrayLevel1: RadioRange_InArrayLevel1,
  RadioRange_NewMaterialUI: RadioRange_NewMaterialUI,
  RadioRange_ra: RadioRange_ra,
  Text_ra: Text_ra,
  Text_ra2: Text_ra2,
  SelectRange_Field: SelectRange_Field,
  SelectRange_InputField: SelectRange_InputField
  //UniformedArrayInline: UniformedArrayInline
}
